<template>
  <v-container
    class="brands-carousel-section-wrapper"
    fluid
    :style="{
      'background-color': data.color,
    }"
  >
    <v-row
      class="title-wrapper pa-md-0"
      fluid
      :style="{
        'background-image':
          'url(' + require('@/assets/images/homepage/' + data.background) + ')',
      }"
    >
      <v-col class="col-12">
        <h2 v-html="data.title"></h2>
      </v-col>
    </v-row>
    <v-row class="carousel-wrapper">
      <v-col class="col-12">
        <VueSlickCarousel v-bind="settings">
          <template v-for="(brand, i) in data.brandsList">
            <v-img
              :key="i"
              contain
              :src="require('@/assets/images/brands/' + brand.image)"
              :alt="brand.title"
              height="80px"
              width="80px"
              :position="!isMobile ? 'center top' : 'center center'"
            />
          </template>
        </VueSlickCarousel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'BrandsCrouselSection',
  components: {
    VueSlickCarousel,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      settings: {
        infinite: true,
        speed: 500,
        slidesToShow:
          this.data.brandsList.length && this.data.brandsList.length <= 7
            ? this.data.brandsList.length
            : 7,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: false,
        autoplay: true,
        responsive: [
          {
            breakpoint: 475,
            settings: {
              slidesToShow: 1,
              swipe: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              swipe: true,
            },
          },
          {
            breakpoint: 1281,
            settings: {
              slidesToShow: 5,
            },
          },
        ],
      },
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  beforeMount() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.brands-carousel-section-wrapper
  padding: 0 12px 45px
  .title-wrapper
    background-repeat: no-repeat
    background-size: cover
    background-position: center top
    min-height: 220px
    margin-bottom: 45px
    .col
      justify-content: center
      align-items: center
      display: flex
      flex-flow: column
      h2
        display: inline-block
        max-width: 850px
        font-family: 'metropolissemi_bold'
        font-style: normal
        font-weight: 600
        font-size: 32px
        color: #ffffff
        line-height: 1.4
        text-align: center
        ::v-deep
          .brand
            font-family: 'metropolisregular'
            font-weight: 400
            span
              font-family: 'metropolisbold'
              font-weight: 700
          b
            color: #003036
  .carousel-wrapper
    margin-left: 8.3333333333%
    margin-right: 8.3333333333%
    padding: 0
    margin-bottom: 45px
    border-bottom: 1px solid #A8A8AD
    img
      max-width: 100%
  @media screen and (max-width: 959px)
    .title-wrapper
      .col
        h2
          font-size: 20px
</style>
